<template>
  <div id="app">
    <keep-alive >
      <router-view  v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view  v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      // schemeUrl:'',
      // downloadUrl:''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.openApp()
    })
  },
  created(){
    console.log('created')
    console.log(JSON.stringify(this.$route.query))
    console.log(JSON.stringify(this.$route.params))
    if(this.$route.query.invId){
      let invId = this.$route.query.invId;
      console.log('saveInvId='+invId)
      this.$store.commit('saveInvId', invId);
    }
    if(this.$route.query.suid){
      let invId = this.$route.query.suid
      console.log('saveInvId.suid='+invId)
      this.$store.commit('saveInvId', invId);
    }
  },
  mounted() {
    console.log('mounted')
    // this.openApp()

  },
  methods: {
    // openApp(){
    //   //这个是安卓操作系统
    //   if (this.isAndroid()) {
    //     this.$dialog.confirm({
    //       title: '提示',
    //       message: '您是安卓手机，可以直接在我惠省钱App打开',
    //       confirmButtonColor: this.m_color
    //     }).then(() => {
    //       //安卓app的scheme协议
    //       window.location.href = 'wohui://com.whsq'
    //       setTimeout(function(){
    //         let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden
    //         if(typeof hidden =="undefined" || hidden ==false){
    //           //应用宝下载地址
    //           window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.lx.whsq'
    //         }
    //       }, 2500);
    //     }).catch(() => {
    //
    //     })
    //
    //   }else{
    //     // alert('H5')
    //     let beforeUrl = localStorage.getItem('beforeUrl')
    //     localStorage.clear()
    //     localStorage.setItem('uid', res.uid)
    //     localStorage.setItem('isBindTb', res.isBindTb)
    //     localStorage.setItem('relation_id', res.relationId)
    //     if (beforeUrl) {
    //       this.$router.replace(beforeUrl)
    //       // console.log(beforeUrl)
    //     } else {
    //       this.$router.replace('/')
    //       // this.$router.push(window.g.BeforeURL)
    //       // console.log(1232)
    //     }
    //   }
    // }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  overflow: auto;
  position: relative;
  /*margin-top: 60px;*/
}
  .mescroll-totop-my{
    position: absolute;
    z-index: 99;
    right: 10px;
    bottom: 70px;
    width: 48px;
    /*height: 60px;*/
    border-radius: 50%;
    max-width: 60px;/*no*/
  }
/deep/ .van-uploader{
  width: 100%;
}
/deep/ .van-uploader__preview,/deep/ .van-uploader__upload{
  width: 22%;
  margin: 2% 1%;
  padding-top: 22%;
  position: relative;
  height: 0;
}
/deep/ .van-uploader__preview-image{
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left: 0;
}
/deep/ .van-uploader__upload-icon{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.mescroll-empty /deep/ .empty-icon {
  width: 30% !important;
  margin-top: 1rem;
}
.van-grid-item /deep/ .van-grid-item__content{
  padding: 4px 4px!important; /*no*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue